export const UPI_LIST_DATA = "UPI_LIST_DATA";
export const UPI_LIST_ERROR_DATA = "UPI_LIST_ERROR_DATA";
export const UPI_LIST_HIDE_ERROR_DATA = "UPI_LIST_HIDE_ERROR_DATA";
export const UPI_LIST_START_LOADER = "UPI_LIST_START_LOADER";
export const UPI_LIST_STOP_LOADER = "UPI_LIST_STOP_LOADER";
